import * as  sdkRouter from './router';
import coreAppUtil from '../../app/lib/appUtil';
import * as reactSupport from '../../app/config/reactsupport';
/*var sdkErrorEvent = Insight.register('sdk-error', {
  level: Insight.EventLevel.Error
});
*/


function has(sdkName) {
    return Boolean(sdkRouter.getConfig(sdkName));
}


function get(sdkName) {
    return sdkRouter.getConfig(sdkName);
}


/**
 * 加载指定的 SDK，异步返回 SDK 导出的 API
 * @param {string} sdkName
 */
function use(sdkName) {

    //var useTrace = Insight.captureTrace('加载 ' + sdkName);


    return new Promise(async function (resolve, rejectPromise) {

        var sdkConfig = await sdkRouter.getConfig(sdkName);

        if (!sdkConfig) {
            rejectPromise(new Error(sdkName + '" 未配置'));
            return;
        }

        var reject = function (reason) {
            // var trace = Insight.concatTrace(Insight.captureTrace(reason), useTrace);
            var trace = []
            rejectPromise(Object.assign(reason, trace));
            /*sdkErrorEvent.push(Object.assign(
              {
                sdkName: sdkName,
                productBlame: 'sdk',
                productId: sdkConfig.productId
              },
              trace
            ));
            */
        };

        var sdkSourceUrl = sdkConfig.content.replace(/http:|https:/, "") + "#" + sdkConfig.component;
        var sdkCssList = sdkConfig.css || [];
        // 替换为配置的 CDN 域名
        var cdnHost = coreAppUtil.getImgcacheUrl();
        if (cdnHost) {
            sdkSourceUrl = sdkSourceUrl.replace("imgcache.qq.com", cdnHost);
            sdkCssList = sdkCssList.map(function (cssUrl) {
                return reactSupport.parsePath(cssUrl.replace("imgcache.qq.com", cdnHost));
            });
        }

        // 加载 JS 资源
        var jsReady = new Promise(function (resolveJs) {
            reactSupport.reactsupport.loadFn(sdkSourceUrl, resolveJs, sdkConfig);
        });



        // 加载 CSS 资源
        var cssReady = new Promise(function (resolveCss) {
            if (!sdkCssList.length) {
                resolveCss();
            } else {
                // Note 1: 使用 seajs 加载，因为已经有资源失败监控和重试逻辑
                // Note 2: css 加载完成后，需要加上 global 标识表示是全局样式，否则会被页面逻辑禁用
                seajs.use(sdkCssList, function () {
                    // 忽略协议、query 对比两个 URL 是否一致
                    // （重试时使用 XHR 加载的 CSS 会带上协议头和增加随机数作为查询参数）
                    var isSameUrl = function (url1, url2) {
                        var normalize = function (url) {
                            return url.split('//').pop().split('?').shift();
                        }
                        return normalize(url1) === normalize(url2);
                    };
                    // 找到所有的样式
                    $('link[rel="stylesheet"]').each(function (i, el) {
                        var $el = $(el);
                        var linkHref = $el.attr('data-origin-href') || $el.attr('href');
                        // 在 SDK 内的样式加上全局标记
                        if (linkHref) {
                            sdkCssList.forEach(function (cssUrl) {
                                if (isSameUrl(cssUrl, linkHref)) {
                                    $el.attr('data-role', 'global');
                                }
                            });
                        }
                    });
                    resolveCss();
                });
            }
        });

        // 90 秒超时，留充足的时间给 seajs 重试
        var failTimer = setTimeout(function () {
            reject(new Error(sdkName + ' 加载超时！'));
        }, 90000);

        // 都加载好之后回调
        Promise.all([jsReady, cssReady]).then(function () {
            clearTimeout(failTimer);
            var sdkModuleId = "sdk/" + sdkName;
            var fail = function () {
                reject(
                    new Error(
                        sdkName + ' 未从指定的入口 "' + sdkSourceUrl + '" 导出'
                    )
                );
            };
            // 成功注册，使用 use 激活 factory
            if (window.seajs.hasDefined[sdkModuleId]) {
                window.seajs.use(sdkModuleId, function (sdkModule) {
                    if (sdkModule) {
                        resolve(sdkModule);
                    }
                    // 注册异常
                    else {
                        fail();
                    }
                });
            }
            // 未成功注册
            else {
                fail();
            }
        }, reject);
    });

}
export { use, get, has }